var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "message-box dialog-mask",
      on: {
        click: function ($event) {
          if ($event.target !== $event.currentTarget) return null
          return _vm.onClickOutSide.apply(null, arguments)
        },
      },
    },
    [
      _c("div", { staticClass: "dialog-box" }, [
        _c("div", { staticClass: "section dialog-header" }, [
          _c("h1", [_vm._v(_vm._s(_vm.$t("plotPage.plotCreateDialog.title")))]),
        ]),
        _c("div", { staticClass: "section dialog-body" }, [
          _c(
            "div",
            { staticClass: "input-container" },
            [
              _c("h2", [
                _vm._v(_vm._s(_vm.$t("plotPage.plotCreateDialog.plotName"))),
              ]),
              _c("input-text", {
                attrs: { maxlength: 120 },
                model: {
                  value: _vm.name,
                  callback: function ($$v) {
                    _vm.name = $$v
                  },
                  expression: "name",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "input-container" },
            [
              _c("h2", [
                _vm._v(
                  _vm._s(_vm.$t("plotPage.plotCreateDialog.selectPlotFormat"))
                ),
              ]),
              _c("select-box", {
                staticClass: "selectbox",
                class: { disabled: _vm.hasLimit },
                attrs: {
                  items: _vm.plotModes,
                  keyAttr: "id",
                  placeholder: _vm.$t(
                    "plotPage.plotCreateDialog.selectPlaceholder"
                  ),
                  selected: _vm.selectedMode,
                  disabled: _vm.hasLimit,
                },
                on: { select: _vm.selectMode },
              }),
              _vm.hasLimit
                ? _c("div", { staticClass: "caution" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("plotPage.plotCreateDialog.freeMemberLimit")
                      )
                    ),
                  ])
                : _vm._e(),
            ],
            1
          ),
        ]),
        _c("div", { staticClass: "section button-area" }, [
          _c(
            "button",
            {
              staticClass: "button cancel",
              on: { click: _vm.onNegativeClick },
            },
            [_vm._v(_vm._s(_vm.negative))]
          ),
          _c(
            "button",
            {
              staticClass: "button primary",
              attrs: { disabled: !_vm.isCompleted },
              on: { click: _vm.onPositiveClick },
            },
            [_vm._v(" " + _vm._s(_vm.positive) + " ")]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }